import "../../styles/index.scss";

import i18next from "i18next";
import * as React from "react";
import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";

import { DEFAULT_LANGUAGE } from "../../../../company/settings/translations";
import global_en from "../../translations/en/global.json";
import global_es from "../../translations/es_ES/global.json";
import { ILink } from "../../types/thecookies";
import Debugger from "../Debugger/Debugger";
// import Whatsapp from "../Whatsapp/Whatsapp";
import { Footer } from "./footer/footer";
import Header from "./header/Header";
import { LayoutContext } from "./LayoutContext";

interface Props {
  children: React.ReactNode;
  lang?: string;
  landingName?: string;
  legalLinks: ILink[];
  navbarLinks: ILink[];
  settings?: {
    postalAddress?: {
      address?: string;
    };
    email?: string;
    phone?: string;
  };
}

const Layout: React.FC<Props> = (props: Props): React.ReactNode => {
  const lng = props.lang || DEFAULT_LANGUAGE;
  i18next.init({
    interpolation: { escapeValue: false },
    lng,
    resources: {
      es_es: {
        global: global_es,
      },
      en: {
        global: global_en,
      },
    },
  });

  function setWidthScreen() {
    document.body.style.setProperty("--width-screen", `${document.body.clientWidth}px`);
  }

  useEffect(() => {
    if (document && window) {
      setWidthScreen();
      window.addEventListener("resize", setWidthScreen);
    }
    return () => {
      if (window) {
        window.removeEventListener("resize", setWidthScreen);
      }
    };
  }, []);

  // i18next.changeLanguage(lang).then(() => {});

  return (
    <LayoutContext.Provider value={{ ...props }}>
      <I18nextProvider i18n={i18next}>
        <div className={`l-${props.landingName}`}>
          <Header />
          {/*<Whatsapp />*/}
          {props.children}
          <Footer />
        </div>
        <Debugger />
      </I18nextProvider>
    </LayoutContext.Provider>
  );
};
export default Layout;
